"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var THEMES = {};
THEMES.CATEGORY = "default_category";
THEMES.MAIN = "main";
THEMES.COLLECTION = "collection";
THEMES.BRAND = "brand";
THEMES.BRAND_LIST = "brand_list";
THEMES.COLLECTION_LIST = "collection_list";
THEMES.INSPIRATION = "inspiration";
THEMES.INSPIRATION_LIST = "inspiration_list";
THEMES.LIST = "list";
var _default = THEMES;
exports["default"] = _default;